"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToothNumberingType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ToothNumberingType_Factory = /** @class */ (function () {
    function ToothNumberingType_Factory() {
    }
    ToothNumberingType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ToothNumberingType1: model.ToothNumberingType1,
            ToothNumberingTypeCode: model.ToothNumberingTypeCode,
        };
        return result;
    };
    ToothNumberingType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ToothNumberingType1: model.ToothNumberingType1,
            ToothNumberingTypeCode: model.ToothNumberingTypeCode,
        };
        return result;
    };
    return ToothNumberingType_Factory;
}());
exports.ToothNumberingType_Factory = ToothNumberingType_Factory;
